import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8 col-xxl-8 col-sm-12 p-0" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { key: 7 }
const _hoisted_15 = { key: 8 }
const _hoisted_16 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_17 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_18 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_19 = { class: "card-title" }
const _hoisted_20 = { class: "mb-0 h2" }
const _hoisted_21 = { style: {"float":"right"} }
const _hoisted_22 = { class: "card-body pt-0" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "d-flex align-items-center py-2" }
const _hoisted_25 = { class: "flex-grow-1" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = {
  key: 0,
  class: "ms-3"
}
const _hoisted_28 = { class: "btn f-w-500 background-light-danger font-danger p-0" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "table" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "col-md-4 col-xxl-4 col-sm-12 p-0" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 1,
  id: "carouselExampleIndicators",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_39 = { class: "carousel-inner" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { key: 2 }
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 0,
  class: "accordion dark-accordion my-5",
  id: "simpleaccordion"
}
const _hoisted_44 = { class: "accordion-item" }
const _hoisted_45 = {
  class: "accordion-collapse",
  id: "collapseOne",
  "aria-labelledby": "headingOne",
  "data-bs-parent": "#simpleaccordion"
}
const _hoisted_46 = { class: "accordion-body" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "text-black fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AddDomaineModal = _resolveComponent("AddDomaineModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-black fw-semibold" }, "Détails d'un produit", -1)),
          _createVNode(_component_router_link, {
            to: "/produits/liste-produits",
            class: "btn btn-primary transition border-0 lh-1 fw-medium",
            style: {"position":"absolute","right":"10px","top":"10px"}
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1" }, null, -1),
              _createTextVNode(" Retour ")
            ])),
            _: 1
          })
        ]),
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", null, "Code Produit", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.produit?.codeProduit), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", null, "Référence", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.produit?.refProd), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", null, "Famille", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.produit?.famille?.libelleFamille), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("td", null, "Nom", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.produit?.nomProd), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", null, "Nom Standar", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.produit?.nomStandar), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("td", null, "Nom Marché", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.produit?.nomMarche), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", null, "Marque :", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.produit?.marqProd?.libelle), 1)
                ]),
                (_ctx.produit?.estModeCarreau)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                      _cache[10] || (_cache[10] = _createElementVNode("td", null, "Est mode Carreau :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.estModeCarreau), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.pieceParCarton)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _cache[11] || (_cache[11] = _createElementVNode("td", null, "Pièce par carton :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.pieceParCarton), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.pieceParMetreCarre)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                      _cache[12] || (_cache[12] = _createElementVNode("td", null, "Pièce par mètre carré :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.pieceParMetreCarre), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.metreCarreParCarton)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "Mètre carré par carton :", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.metreCarreParCarton), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.surfaceParPiece)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", null, "Surface par pièce:", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.surfaceParPiece), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.couleur)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", null, "Couleur:", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.couleur), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.paysProduction)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", null, "Pays d'origine:", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.paysProduction), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.uniteGestion)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _cache[17] || (_cache[17] = _createElementVNode("td", null, "Unité de gestion:", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.uniteGestion?.libelle), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.produit?.uniteStock)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _cache[18] || (_cache[18] = _createElementVNode("td", null, "Unité de Stock:", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.produit?.uniteStock?.libelle), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.produit?.descProd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "text-black fw-bold mt-4" }, "Description du produit", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.produit?.descProd), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h4", _hoisted_20, [
                    _cache[21] || (_cache[21] = _createTextVNode("Domaines de produit ")),
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("a", {
                        class: "btn btn-primary btn-sm mt-3",
                        href: "#",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#AddDomaineModal",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAddDomaineModal(_ctx.produit)))
                      }, _cache[20] || (_cache[20] = [
                        _createElementVNode("i", { class: "fa fa-lock lh-2 me-8 position-relative top-1" }, null, -1),
                        _createTextVNode(" Ajouter un domaine ")
                      ]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.domaineproduits, (domaineproduit, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-4",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "bullet bg-primary me-3" }, null, -1)),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(domaineproduit.domaineActivite?.libelle), 1)
                          ]),
                          (index !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("span", _hoisted_28, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.suppDomaineActivite(domaineproduit.id))
                                  }, _cache[23] || (_cache[23] = [
                                    _createElementVNode("i", { class: "fa fa-trash-o lh-2 me-8 position-relative top-1" }, null, -1)
                                  ]), 8, _hoisted_29)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col" }, [
                _createElementVNode("h5", { class: "text-black fw-bold mt-4" }, "Conditionnements du produit")
              ], -1)),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: { name: 'AddProduitConditionnement', params: { id: _ctx.produit?.id } },
                  class: "btn btn-primary mt-3 text-center"
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createElementVNode("i", { class: "fa fa-plus-circle lh-2 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode(" Compléter un conditionnement ")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createElementVNode("table", _hoisted_32, [
              _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Conditionnement"),
                  _createElementVNode("th", null, "Qté Condit."),
                  _createElementVNode("th", null, "UM"),
                  _createElementVNode("th", null, "Action")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.produitconditionnements, (produitconditionnement, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(produitconditionnement.conditionnement?.libelle), 1),
                    _createElementVNode("td", null, _toDisplayString(produitconditionnement.qteCond), 1),
                    _createElementVNode("td", null, _toDisplayString(produitconditionnement.conditionnement2?.libelle), 1),
                    _createElementVNode("td", null, [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, [
                              _createElementVNode("a", {
                                class: "bullet me-3 btn f-w-500 background-light-danger font-danger",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(produitconditionnement.id, _ctx.produit?.produitconditionnements, 'produitconditionnement', `le conditionnement ${produitconditionnement.conditionnement.libelle}`))
                              }, _cache[26] || (_cache[26] = [
                                _createElementVNode("i", { class: "fa fa-trash-o lh-2 me-8 position-relative top-1" }, null, -1)
                              ]), 8, _hoisted_35)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "text-black fw-bold mb-10" }, "Image du Produit", -1)),
            _cache[32] || (_cache[32] = _createElementVNode("hr", null, null, -1)),
            (_ctx.produit?.imagePrincipal)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getUrlApiForProductFiles(_ctx.produit?.imagePrincipal),
                  class: "d-block w-100",
                  alt: "Photo"
                }, null, 8, _hoisted_37))
              : _createCommentVNode("", true),
            _cache[33] || (_cache[33] = _createElementVNode("hr", null, null, -1)),
            (_ctx.medias.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "carousel-indicators" }, [
                    _createElementVNode("button", {
                      type: "button",
                      "data-bs-target": "#carouselExampleIndicators",
                      "data-bs-slide-to": "0",
                      class: "active",
                      "aria-current": "true",
                      "aria-label": "Slide 1"
                    }),
                    _createElementVNode("button", {
                      type: "button",
                      "data-bs-target": "#carouselExampleIndicators",
                      "data-bs-slide-to": "1",
                      "aria-label": "Slide 2"
                    }),
                    _createElementVNode("button", {
                      type: "button",
                      "data-bs-target": "#carouselExampleIndicators",
                      "data-bs-slide-to": "2",
                      "aria-label": "Slide 3"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medias, (media, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["carousel-item", index == 0 ? 'active' : '']),
                        key: index
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getUrlApiForProductFiles(media.nomMedia),
                          class: "d-block w-100",
                          alt: "Photo"
                        }, null, 8, _hoisted_40)
                      ], 2))
                    }), 128))
                  ]),
                  _cache[30] || (_cache[30] = _createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide=\"prev\" data-v-519b5375><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-519b5375></span><span class=\"visually-hidden\" data-v-519b5375>Précédent</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide=\"next\" data-v-519b5375><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-519b5375></span><span class=\"visually-hidden\" data-v-519b5375>Suivant</span></button>", 2))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("img", {
                    src: _ctx.getUrlApiForProductFiles(null),
                    class: "d-block w-100",
                    alt: "Photo"
                  }, null, 8, _hoisted_42)
                ]))
          ]),
          (_ctx.produit?.produitchampslibres.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[35] || (_cache[35] = _createStaticVNode("<h2 class=\"accordion-header\" id=\"headingOne\" data-v-519b5375><button class=\"accordion-button bg-light-primary font-primary\" type=\"button\" data-bs-target=\"#collapseOne\" aria-expanded=\"true\" aria-controls=\"collapseOne\" data-v-519b5375>Champs descriptifs<i class=\"vue-feather vue-feather--chevron-down svg-color\" data-name=\"chevron-down\" data-tags=\"expand\" data-type=\"chevron-down\" data-v-519b5375><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-down vue-feather__content\" data-v-519b5375><polyline points=\"6 9 12 15 18 9\" data-v-519b5375></polyline></svg></i></button></h2>", 1)),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.produitchampslibres, (champs, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col-md-3",
                            key: index
                          }, [
                            _createElementVNode("span", _hoisted_48, _toDisplayString(champs.champslibre.libelleChamp), 1),
                            _cache[34] || (_cache[34] = _createTextVNode(": ")),
                            _createElementVNode("span", null, _toDisplayString(champs.valeur), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_AddDomaineModal, {
      selectedProduit: _ctx.selectedProduit,
      onClose: _ctx.reloadUserData,
      onGetAllProduits: _ctx.reloadUserData
    }, null, 8, ["selectedProduit", "onClose", "onGetAllProduits"])
  ], 64))
}